import { format, parse, differenceInYears } from "date-fns";

const formatFromPTtoEN = date => {
  return format(parse(date, "dd/MM/yyyy", new Date()), "yyyy-MM-dd");
};

const formatFromENtoPT = date => {
  return format(parse(date, "yyyy-MM-dd", new Date()), "dd/MM/yyyy");
};

const differenceInYearsFromNow = date => {
  return differenceInYears(new Date(), parse(date, "dd/MM/yyyy", new Date()));
};

export { formatFromPTtoEN, formatFromENtoPT, differenceInYearsFromNow };
